import WorkerState from '../../../../../shared/model/WorkerState';

export class WorkerCreateRequest {

    // WorkerContractorSave {
    //   contractor_id: number
    //   document_schema_id: number
    // }

    _dni; // string
    _name; // string
    _position; // string
    _lastName; // string
    _agreement; // string
    _contractors; // WorkerContractorSave[]
    _workerStateId; // number

    constructor(values) {
        this._dni = values.dni;
        this._name = values.name;
        this._position = values.job;
        this._lastName = values.lastName;
        this._agreement = values.agreement;
        this._contractors = this._parseContractorSchemas(values);
        this._workerStateId = values.state ? WorkerState.ACTIVE : WorkerState.INACTIVE;
    }

    body() {
        return {
            dni: this._dni,
            name: this._name,
            position: this._position,
            last_name: this._lastName,
            agreement: this._agreement,
            contractors: this._contractors,
            worker_state_id: this._workerStateId,
        };
    }

    _parseContractorSchemas(values) {
        return values.contractorSchemas
                     .filter((schema) => schema.schema.length !== 0)
                     .map((s) => ( {
                         contractor_id: s.contractorId,
                         document_schema_id: s.schema[0].value,
                         position: s.position,
                     } ));
    }
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/worker/form/create/worker-create/WorkerCreateRequest.js